/* eslint-disable */
import { dispatch } from 'd3';
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { fetchCCTAnotator, submitCCTAnotator } from '../../../legacy/containers/ApiUrls'
import beat from './data/beatAnnotation.json'
import sample from './data/sample.json'
//=====================
//  Rx Type Constant
//=====================
const ACTION_PREFIX = 'ANNOTATOR.'
const WorkingEcgID = "9hf2t7f9lnoy4padqwetjrwd9"

export const INIT = `${ACTION_PREFIX}INIT`
export const FETCH_INIT = `${ACTION_PREFIX}FETCH_INIT`
export const SUBMIT_COMPLETED = `${ACTION_PREFIX}SUBMIT_COMPLETED`
export const FETCH_RECORDING_INFO = `${ACTION_PREFIX}FETCH_RECORDING_INFO`
export const FETCH_BASE_RHYTHM = `${ACTION_PREFIX}FETCH_BASE_RHYTHM`
export const SELECT_LEAD = `${ACTION_PREFIX}SELECT_LEAD`
export const DESELECT_LEAD = `${ACTION_PREFIX}DESELECT_LEAD`
export const HANDLE_SUBMIT = `${ACTION_PREFIX}HANDLE_SUBMIT`
export const ADD_BEAT = `${ACTION_PREFIX}ADD_BEAT`
export const DELETE_BEAT = `${ACTION_PREFIX}DELETE_BEAT`
export const MODIFY_BEAT = `${ACTION_PREFIX}MODIFY_BEAT`
export const ADD_INTR = `${ACTION_PREFIX}ADD_INTR`
export const DELETE_INTR = `${ACTION_PREFIX}DELETE_INTR`
export const UPDATE_INTR = `${ACTION_PREFIX}UPDATE_INTR`
export const UPDATE_INTR_CONTEXT = `${ACTION_PREFIX}UPDATE_INTR_CONTEXT`
export const UPDATE_CONTEXT = `${ACTION_PREFIX}UPDATE_CONTEXT`
export const UPDATE_GHOST_BEAT = `${ACTION_PREFIX}UPDATE_GHOST_BEAT`
export const UPDATE_GHOST_INTR = `${ACTION_PREFIX}UPDATE_GHOST_INTR`
export const UPDATE_MOUSE = `${ACTION_PREFIX}UPDATE_MOUSE`
export const ADD_HIGHLIGHT = `${ACTION_PREFIX}ADD_HIGHLIGHT`
export const DELETE_HIGHLIGHT = `${ACTION_PREFIX}DELETE_HIGHLIGHT`

//============
//  Actions
//============
export const init = (payload) => ({
    type: INIT,
    payload
})
export const selectLead = (payload) => ({
    type: SELECT_LEAD,
    payload
})
export const deselectLead = (payload) => ({
    type: DESELECT_LEAD,
    payload
})
export const initFetch = (payload = null) => ({
    type: FETCH_INIT,
    payload
})

export const addBeat = (type, beatIndex) => ({
    type: ADD_BEAT,
    payload: [beatIndex, type]
})

export const removeBeat = (beatIndex) => ({
    type: DELETE_BEAT,
    payload:beatIndex
})

export const modifyBeat = (beatIndex,newValue) => ({
    type: MODIFY_BEAT,
    payload:[beatIndex,newValue]
})

export const addIntr = (payload) => ({
    type: ADD_INTR,
    payload: payload
})

export const removeIntr = (beatIndex) => ({
    type: DELETE_INTR,
    payload:beatIndex
})

export const updateIntr = (index,value) => ({
    type: UPDATE_INTR,
    payload: [index,value]
})

export const updateContext = (payload) => ({
    type: UPDATE_CONTEXT,
    payload
})

export const updateIntrContext = (payload) => ({
    type: UPDATE_INTR_CONTEXT,
    payload
})

export const updateGhostBeat = (payload) => ({
    type: UPDATE_GHOST_BEAT,
    payload
})

export const updateGhostIntr = (payload) => ({
    type: UPDATE_GHOST_INTR,
    payload
})

export const updateMouse = (payload) => ({
    type: UPDATE_MOUSE,
    payload
})

export const addHighlight = (payload) => ({
    type: ADD_HIGHLIGHT,
    payload
})

export const deleteHighlight = (payload) => ({
    type: DELETE_HIGHLIGHT,
    payload
})


//==================
//  Initial State
//==================
const initialState = {
    selectedLead : null,
    recordingId : null,
    samples : {},
    baseRhythm: {},
    recordingInfo : {
        isfetching : true,
        annotation : {
            inbox : null,
            acuity : null,
        }
    },
    interpretation : {
        beats:[[0,4]],
        intervals:[],
        // ...beat,
    },
    context : {
        show : false,
        data : {
            top:0,
            left:0,
            showDelete:false,
            beatIndex:0,
        }
    },
    intrervalMenu : {
        show : false,
        top: 0,
        left: 0,
        index: null,
        currentType: null,
        intrData: null,
    },
    ghostBeat : {
        show : false,
        coordinates : [0,0],
        type : 0,
        index : 'ghost-beat',
    },
    interval : {
        show : false,
        coordinates : [0,0,0,0],
        type : 0,
        index : 'ghost-interval',
    },
    highlight :{
        LeadData : null,
        centerIndex : null
    },
    mouse : {
        mousedown : false,
        mouseDownOnBeat : false,
        mouseDownOnBeatType : null,
        posX : null,
        posY : null,
        iStart : null,
        bStart : null,
        dragging: null,
    }
}

//============
//  Reducer
//============
export const annotatorReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case INIT:
        return {
          ...initialState,
          recordingId: payload,
        };

      case FETCH_RECORDING_INFO:
        const interpretation = JSON.parse(payload.annotation.data);
        const highlight_interval = JSON.parse(payload.annotation.highlight_interval) ? JSON.parse(payload.annotation.highlight_interval)[0] : null;
        return {
          ...state,
          samples: {
            ...state.samples,
            ...payload.recording.enhanced_data,
          },
          interpretation: {
            ...state.interpretation,
            ...interpretation,
          },
          recordingInfo: {
            ...state.recordingInfo,
            ...payload,
            isfetching: false,
          },
          highlight: { 
            ...state.highlight,
            ...highlight_interval
          }
        };

      // For getting the Base Rythms
      case FETCH_BASE_RHYTHM:
        return {
          ...state,
          baseRhythm: [...payload],
        };

      case ADD_BEAT:
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            beats: [...state.interpretation.beats, payload],
          },
        };

      case DELETE_BEAT:
        const filteredBeats = state.interpretation.beats.filter(
          b => b[0] != payload,
        );
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            beats: [...filteredBeats],
          },
        };

      case MODIFY_BEAT:
        const filteredBeatsModified = state.interpretation.beats.filter(
          b => b[0] != payload[0],
        );
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            beats: [...filteredBeatsModified, payload[1]],
          },
        };

      case ADD_INTR:
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            intervals: [...state.interpretation.intervals, payload],
          },
        };

      case DELETE_INTR:
        const filteredIntervals = state.interpretation.intervals.filter(
          b => b.start != payload,
        );
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            intervals: [...filteredIntervals],
          },
        };

      case UPDATE_INTR:
        const filteredIntervalsModified = state.interpretation.intervals.filter(
          b => b.start != payload[0],
        );
        return {
          ...state,
          interpretation: {
            ...state.interpretation,
            intervals: [...filteredIntervalsModified, payload[1]],
          },
        };

      case UPDATE_INTR_CONTEXT:
        return {
          ...state,
          intrervalMenu: {
            ...state.intrervalMenu,
            ...payload,
          },
        };

      case UPDATE_CONTEXT:
        return {
          ...state,
          context: {
            ...state.context,
            ...payload,
          },
        };

      case UPDATE_GHOST_BEAT:
        return {
          ...state,
          ghostBeat: {
            ...state.ghostBeat,
            ...payload,
          },
        };

      case UPDATE_GHOST_INTR:
        return {
          ...state,
          interval: {
            ...state.interval,
            ...payload,
          },
        };

      case UPDATE_MOUSE:
        return {
          ...state,
          mouse: {
            ...state.mouse,
            ...payload,
          },
        };

      case FETCH_INIT:
        return {
          ...state,
          recordingInfo: {
            ...state.recordingInfo,
            isfetching: true,
          },
        };

      case SUBMIT_COMPLETED:
        return {
          ...state,
          recordingInfo: {
            ...state.recordingInfo,
            annotation: {
              ...state.recordingInfo.annotation,
              ...payload,
            },
            isfetching: false,
          },
        };

      case SELECT_LEAD:
        return {
          ...state,
          selectedLead: payload,
        };

      case DESELECT_LEAD:
        return {
          ...state,
          selectedLead: null,
        };

      case HANDLE_SUBMIT:
        return {
          ...state,
        };

      case ADD_HIGHLIGHT:
        return {
          ...state,
          highlight: {
            ...payload,
          },
        };

      case DELETE_HIGHLIGHT:
        return {
          ...state,
          highlight: {
            LeadData : null,
            centerIndex : null
          },
        };

      default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/state.js